module.exports = __webpack_public_path__ + "img/satisfaction-logo.42ef26ad.svg";